import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { applyDirAndFontForLang, SUPPORTED_LANGS } from '../i18n';

const LABELS: Record<string, string> = {
  it: 'Italiano',
  en: 'English',
  fr: 'Français',
  de: 'Deutsch',
  es: 'Español',
  ar: 'العربية',
  zh: '中文',
  ro: 'Română',
  uk: 'Українська',
  ru: 'Русский',
};

export function LangSwitcher() {
  const { i18n } = useTranslation();

  useEffect(() => {
    applyDirAndFontForLang(i18n.resolvedLanguage ?? 'it');
  }, [i18n.resolvedLanguage]);

  return (
    <select
      value={i18n.resolvedLanguage ?? 'it'}
      onChange={(e) => {
        void i18n.changeLanguage(e.target.value);
      }}
      className="rounded-md border bg-transparent px-2 py-1 text-xs"
      style={{
        borderColor: 'var(--line)',
        color: 'var(--ink)',
        background: 'var(--paper)',
      }}
      aria-label="Lingua"
    >
      {SUPPORTED_LANGS.map((l) => (
        <option key={l} value={l}>
          {LABELS[l] ?? l}
        </option>
      ))}
    </select>
  );
}
